import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Form, FormGroup, FormControl, HelpBlock, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { showBannerMessage, clearBannerMessage } from '../../actions/actions';
import { checkForDuplicate } from '../../helpers/utility';
import { MAX_LIST_NAME_LENGTH } from '../../global-constants'

export class AddListClass extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			newListName: '',
			showPopover: false,
		}
	}

	componentDidMount() {
		const nameElement = document.getElementById('new_list_name');
		nameElement.focus();
	}

	onKeyDown = e => {
		if (e.key === 'Enter') {
			this.updateListName(e)
		} else if (e.key === 'Escape') {
			this.setState({newListName: ''}, () => {this.updateListName()} );
			this.props.hideInput();
			e.preventDefault();
		}
	}

	updateListName = e => {
		const { newListName } = this.state;
		const { allLists, setBanner, clearBanner, createList, tree } = this.props;
		const nameElement = document.getElementById('new_list_name');

		clearBanner();
		e.preventDefault();

		// Length should be restricted by input field maxlength, but ensure it here
		if (newListName.length > 0 && newListName.length <= MAX_LIST_NAME_LENGTH) {
			if (checkForDuplicate(allLists, newListName, setBanner)) {
				// Name is not a duplicate, update and exit edit mode
				createList(
					newListName,
					// can't create lists without at least one value in distList,
					// so add the root ID so that we have something to start with
					[tree.root.value.id]
				);
				this.setState({newListName: '', showPopover: false});
			} else {
				// Name is a duplicate, continue editing
				nameElement.focus();
			}
		}
	}

	validationState() {
		const { newListName, showPopover } = this.state;
		const length = newListName.length;
		if (length === MAX_LIST_NAME_LENGTH) {
			if (!showPopover) {
				this.setState({showPopover: true});
			}
		} else if (showPopover) {
			this.setState({showPopover: false});
		}

		return null;
	}

	render() {
		const { i18n, allLists } = this.props;
		const { showPopover } = this.state;

		return(
			<div id='add_list'>
				<Form inline>
					<div className="form-contents">
						<FormGroup
							controlId="new_list_name"
							validationState={this.validationState()}
						>
							<FormControl
								type="text"
								maxLength={MAX_LIST_NAME_LENGTH}
								placeholder={i18n.t('LIST_NAME')}
								onChange={e => this.setState({newListName: e.currentTarget.value})}
								onKeyDown={e => this.onKeyDown(e) }
								value={this.state.newListName}
							/>
							{/* <FormControl.Feedback /> */}
							{/* <HelpBlock>Validation is based on string length.</HelpBlock> */}
						</FormGroup>
						<Popover
							hidden={!showPopover}
							id="popover-basic"
							placement="bottom"
						>
							{i18n.t('MAXIMUM_LIST_NAME_LENGTH', {length: MAX_LIST_NAME_LENGTH})}
						</Popover>
						<Button
							bsStyle='primary'
							bsSize='small'
							onClick={(e) => { this.updateListName(e); }}
						>
							{i18n.t('ADD')}
						</Button>
					</div>
				</Form>
			</div>
		)
	}
}

AddListClass.propTypes = {
	i18n: PropTypes.shape({}).isRequired,
	tree: PropTypes.shape({}).isRequired,
	createList: PropTypes.func.isRequired,
	setBanner: PropTypes.func.isRequired,
	clearBanner: PropTypes.func.isRequired,
	hideInput: PropTypes.func.isRequired,
	allLists: PropTypes.array,
};

AddListClass.defaulstPropTypes = {
	allLists: [],
}

const mapDispatchToProps = dispatch => ({
	setBanner: (message, messageType) => { dispatch(showBannerMessage(message, messageType)) },
	clearBanner: () => { dispatch(clearBannerMessage()) },
});

const mapStateToProps = (state) => ({
	allLists: state.allLists,
});

const AddList = connect(
	mapStateToProps,
	mapDispatchToProps
)(AddListClass);

export default AddList;
